export const color = {
    gray: {
        alt: '#D8D8D8',
        darkest: '#686868',
        darker: '#757575',
        dark: '#ADADAD',
        base: '#A6A7A7',
        light: '#F1F1F1',
        lighter: '#FBFBFB',
        lightest: '#F8FAFC',
        white: '#FFFFFF',
        black: '#1C1C1B',
    },
    body: { base: '#FFFFFF' },
    base: { base: '#1C1C1B' },
    paragraph: { base: '#6F6F6E' },
    border: {
        base: '#E6EBEE',
        input: '#B6BCC8',
    },
    text: { base: '#0D163C' },
    error: {
        base: '#D70E24',
        hover: '#A70D04',
    },
    type: {
        payment: '#293057',
        summons: '#ee7f05',
        post: '#57a619',
        annotations: '#7E20ad',
        processSteps: '#2071ad',
        letters: '#d95555',
    },
    notice: {
        info: {
            text: '#145F96',
            artwork: '#2071AD',
            background: '#C0D8F7',
        },
        success: {
            text: '#437317',
            artwork: '#4F9F11',
            background: '#C6DFB5',
        },
        warning: {
            text: '#CD711B',
            artwork: '#EE7F05',
            background: '#FBCEB2',
        },
        error: {
            text: '#BF3939',
            artwork: '#D95555',
            background: '#F3B4B4',
        },
    },
};
export const theme = {
    inkassier: {
        primary: {
            base: '#293057',
            dark: '#002044',
            hover: '#002044',
            disabled: '#757575',
        },
        secondary: {
            base: '#FF8300',
            hover: '#cc6800',
            disabled: '#757575',
        },
        tertiary: {
            base: '#2071AD',
            hover: '#195a8a',
            disabled: '#757575',
        },
        auth: {
            background: '#293057',
        },
        font: {
            base: 'Source Sans Pro Webfont',
            head: 'Source Sans Pro Webfont',
        },
    },
    invoned: {
        primary: {
            base: '#59256B',
            hover: '#601E6F',
            dark: '#2D073F',
            light: '#FAE2FF',
            extraLight: '#FAE2FF',
            disabled: '#FAE2FF',
        },
        secondary: {
            base: '#FFC600',
            hover: '#FFC600',
            disabled: '#FFF4CC',
        },
        tertiary: {
            base: '#FFC600',
            hover: '#FFC600',
            disabled: '#FFF4CC',
        },
        auth: {
            background: '#E5E5FD',
        },
        font: {
            base: 'Plus Jakarta Sans',
            head: 'Prometo Webfont',
        },
    },
};
